//
//
//
//
//
//
//
//
//


import targets from '~/mixins/targets'

export default {
  mixins: [targets],
  props: {
    showcase: Object,
    showcaseId: String,
    catSlug: String,
    smallTicketItems: {
      type: Boolean,
      default: false
    }
  }
}
